
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"16","viewBox":"0 0 23 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.246 1.75c-.242 0-.488.07-.71.223L16.25 4.645V2.367C16.25 1.336 15.344.5 14.227.5H2.023C.906.5 0 1.336 0 2.367v11.266C0 14.664.906 15.5 2.023 15.5h12.204c1.117 0 2.023-.836 2.023-1.867v-2.277l4.285 2.667c.223.157.473.223.711.223.649 0 1.254-.508 1.254-1.23V2.98c0-.722-.605-1.23-1.254-1.23zm-6.871 4.063v7.769a.255.255 0 01-.148.043H2.023a.229.229 0 01-.148-.043V2.418a.255.255 0 01.148-.043h12.204c.078 0 .125.023.148.043v3.394zm6.25 6.062L16.25 9.148V6.855l4.375-2.726v7.746z","fill":"#0B0E1F"}})])
          )
        }
      }
    